<template>
  <div
    class="template-usage-list-item d-flex ga-2 align-start px-8 py-3"
    role="link"
    tabindex="0"
    @click="handleOpenProfile"
    @keydown.enter="handleOpenProfile"
  >
    <div
      class="template-usage-list-item-checkbox flex-shrink-0 d-flex align-center"
      @click.stop
    >
      <v-checkbox-btn
        v-if="isOutdated"
        :model-value="selected"
        color="primary"
        density="compact"
        :aria-label="`Select ${profile.title || 'job profile'}`"
        @update:model-value="emit('toggle', profile.ulid)"
      />
    </div>

    <div class="d-flex flex-column ga-1 flex-grow-1 min-w-0">
      <div class="d-flex ga-2 align-center justify-space-between">
        <div class="text-h3 text-textDarkest flex-grow-1 min-w-0">
          {{ profile.title }}
        </div>

        <DpplTooltip
          v-if="isOk"
          class="flex-shrink-0"
          tooltip-placement="top"
          teleport
          max-width="max-content"
        >
          <template #activator="{ onMouseenter, onMouseleave }">
            <span
              @mouseenter="onMouseenter"
              @mouseleave="onMouseleave"
            >
              <StatusPill
                status-key="up_to_date"
                label="OK"
              />
            </span>
          </template>
          <template #tooltip-content>
            <span class="text-body-2">
              This profile's template content is up to date
            </span>
          </template>
        </DpplTooltip>

        <StatusPill
          v-else-if="isUpdating"
          class="flex-shrink-0"
          variant="template-updating"
          icon="mdi-sync"
          icon-type="mdi"
          label="Updating"
        />

        <StatusPill
          v-else
          class="flex-shrink-0"
          variant="flsa-status-mismatch"
          icon="mdi-sync-problem"
          icon-type="mdi"
          label="Outdated"
        />
      </div>

      <JobProfileMeta
        :profile="profile"
        text-class="text-body-2 text-textDark"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import JobProfileMeta from '@/components/jobProfiles/editor/JobProfileMeta.vue';
import StatusPill from '@/components/shared/StatusPill.vue';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

const props = defineProps({
  profile: {
    type: Object,
    required: true,
  },
  status: {
    type: String,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);

const router = useRouter();

const isOutdated = computed(() => props.status === 'outdated');
const isUpdating = computed(() => props.status === 'updating');
const isOk = computed(() => props.status === 'ok');

const handleOpenProfile = () => {
  router.push({ name: 'job-profile-view', params: { id: props.profile.ulid } });
};
</script>

<style scoped lang="less">
.template-usage-list-item {
  cursor: pointer;

  &:hover {
    background: @bg-canvas;
  }
}

.template-usage-list-item-checkbox {
  width: 24px;
  align-self: flex-start;
  height: 24px;
}
</style>
